<script>
import axios from 'axios'
import Store from '@/store'

var apikey = {
  headers: {
    'x-api-key': 'RggO1HXsBT1jNYVDWhN9w9TRMZRpvTEoaFfI8114',
    'Content-Type': 'application/json'
  }
}

// var basePath = 'https://r299s44wvb.execute-api.ap-northeast-1.amazonaws.com/dev'
var basePath = 'https://player.cpucloud.jp/v1'

export default {
  name: 'apiaccess',
  methods: {
    async $_Api_Login (postData) {
      try {
        var loginInfo = await axios.post(basePath + '/users/login', postData, apikey)
        if (loginInfo !== undefined) {
          return loginInfo.data
        }
      } catch (error) {
        if (error.response !== undefined && error.response.status === 404) {
          return error.response.data.message
        }
      }
      return undefined
    },
    async $_Api_GetThumbnail (token, planid) {
      var configAuth = {
        headers: {
          'Authorization': 'Bearer ' + token,
          'Content-Type': 'application/json'
        }
      }
      try {
        var thumData = await axios.post(basePath + '/thumbnail/' + planid, '', configAuth)
        return thumData.data.url
      } catch (error) {
        Store.commit('logout')
        this.$router.push('/Login')
      }
      return undefined
    },
    async $_Api_DeletePlan (token, planid) {
      var configAuth = {
        headers: {
          'Authorization': 'Bearer ' + token,
          'Content-Type': 'application/json'
        }
      }
      try {
        await axios.delete(basePath + '/plans/' + planid, configAuth)
      } catch (error) {
        Store.commit('logout')
        this.$router.push('/Login')
      }
    },
    async $_Api_GetQRImage (planid) {
      try {
        var imageData = await axios.post(basePath + '/qr/' + planid, '', apikey)
        return 'data:image/png;base64,' + imageData.data
      } catch (error) {
      }
      return undefined
    },
    async $_Api_GetSnsUrl (postData) {
      try {
        var url = await axios.post(basePath + '/sns/page', postData, apikey)
        return url.data
      } catch (error) {
      }
      return undefined
    },
    async $_Api_SetPlanInfo (token, planid, planinfo) {
      var configAuth = {
        headers: {
          'Authorization': 'Bearer ' + token,
          'Content-Type': 'application/json'
        }
      }
      try {
        return await axios.put(basePath + '/plans/' + this.PlanData.planid, planinfo, configAuth)
      } catch (error) {
        Store.commit('logout')
        this.$router.push('/Login')
      }
      return undefined
    },
    async $_Api_GetPlanList (token, companyid) {
      var configAuth = {
        headers: {
          'Authorization': 'Bearer ' + token,
          'Content-Type': 'application/json'
        }
      }
      try {
        var resPlanList = await axios.get(basePath + '/plans/list/' + companyid, configAuth)
        return resPlanList.data
      } catch (error) {
        Store.commit('logout')
        this.$router.push('/Login')
      }
      return undefined
    },
    async $_Api_GetUserInfo (token, companyid) {
      var configAuth = {
        headers: {
          'Authorization': 'Bearer ' + token,
          'Content-Type': 'application/json'
        }
      }
      try {
        return await axios.get(basePath + '/users/' + companyid, configAuth)
      } catch (error) {
        Store.commit('logout')
        this.$router.push('/Login')
      }
      return undefined
    },
    async $_Api_GetLogList (token, companyid, starttime, endtime, page, perPage, planid) {
      var params = {}
      if (starttime) params.start = starttime
      if (endtime) params.end = endtime
      if (page !== undefined && page !== null) params.page = page
      if (perPage !== undefined && perPage !== null) params.per_page = perPage
      if (planid !== undefined && planid !== null) {
        if (Array.isArray(planid)) params.planid = planid.join(',')
        else params.planid = planid
      }

      var configAuth = {
        headers: {
          'Authorization': 'Bearer ' + token,
          'Content-Type': 'application/json'
        },
        params: params
      }
      try {
        return await axios.get(basePath + '/log/' + companyid, configAuth)
      } catch (error) {
        // Only force logout when authentication errors occur
        Store.commit('logout')
        this.$router.push('/Login')
      }
      return undefined
    },
    async $_Api_GetAggregateList (token, starttime, endtime) {
      var configAuth = {
        headers: {
          'Authorization': 'Bearer ' + token,
          'Content-Type': 'application/json'
        },
        params: {
          'start': starttime,
          'end': endtime
        }
      }
      try {
        return await axios.get(basePath + '/log/list', configAuth)
      } catch (error) {
        Store.commit('logout')
        this.$router.push('/Login')
      }
      return undefined
    },
    async $_Api_GetUserList (token) {
      var configAuth = {
        headers: {
          'Authorization': 'Bearer ' + token,
          'Content-Type': 'application/json'
        }
      }
      try {
        return await axios.get(basePath + '/users/list', configAuth)
      } catch (error) {
        Store.commit('logout')
        this.$router.push('/Login')
      }
      return undefined
    },
    async $_Api_UpdatePlanList (token, companyid, updateDatas) {
      var bodyInfo = {
        'datas': updateDatas
      }

      var configAuth = {
        headers: {
          'Authorization': 'Bearer ' + token,
          'Content-Type': 'application/json'
        }
      }
      try {
        var res = await axios.put(basePath + '/plans/list/' + companyid, bodyInfo, configAuth)
        return res.status === 200
      } catch (error) {
        Store.commit('logout')
        this.$router.push('/Login')
      }
      return false
    },
    async $_Api_PrivatePlanList (token, companyid, plans) {
      var updateDatas = []
      for (var i = 0; i < plans.length; i++) {
        var plan = plans[i]
        var data = {
          'planid': plan.planid,
          'publicflg': false
        }
        updateDatas.push(data)
      }

      if (await this.$_Api_UpdatePlanList(token, companyid, updateDatas)) {
        for (var j = 0; j < plans.length; j++) {
          plans[j].publicflg = false
        }
        return true
      } else {
        return false
      }
    },
    async $_Api_PublicPlanList (token, companyid, plans) {
      var updateDatas = []
      for (var i = 0; i < plans.length; i++) {
        var plan = plans[i]
        var data = {
          'planid': plan.planid,
          'publicflg': true
        }
        updateDatas.push(data)
      }

      if (await this.$_Api_UpdatePlanList(token, companyid, updateDatas)) {
        for (var j = 0; j < plans.length; j++) {
          plans[j].publicflg = true
        }
        return true
      } else {
        return false
      }
    },
    async $_Api_UnlockPlanList (token, companyid, plans) {
      var updateDatas = []
      for (var i = 0; i < plans.length; i++) {
        var plan = plans[i]
        var data = {
          'planid': plan.planid,
          'protectflg': false
        }
        updateDatas.push(data)
      }

      if (await this.$_Api_UpdatePlanList(token, companyid, updateDatas)) {
        for (var j = 0; j < plans.length; j++) {
          if (!plans[j].disableprotectflg) {
            plans[j].protectflg = false
          }
        }
        return true
      } else {
        return false
      }
    },
    async $_Api_LockPlanList (token, companyid, plans) {
      var updateDatas = []
      for (var i = 0; i < plans.length; i++) {
        var plan = plans[i]
        var data = {
          'planid': plan.planid,
          'protectflg': true
        }
        updateDatas.push(data)
      }

      if (await this.$_Api_UpdatePlanList(token, companyid, updateDatas)) {
        for (var j = 0; j < plans.length; j++) {
          if (!plans[j].disableprotectflg) {
            plans[j].protectflg = true
          }
        }
        return true
      } else {
        return false
      }
    },
    async $_Api_DeletePlanList (token, companyid, plans) {
      var configAuth = {
        headers: {
          'Authorization': 'Bearer ' + token,
          'Content-Type': 'application/json'
        },
        data: {
          'datas': plans
        }
      }
      try {
        await axios.delete(basePath + '/plans/list/' + companyid, configAuth)
        return 'ok'
      } catch (error) {
        if (error.response !== undefined && error.response.status === 404) {
          return error.response.data.message
        }
        Store.commit('logout')
        this.$router.push('/Login')
      }
      return 'error'
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/ApiAccess.vue